/**
 * The kin brand mark in the header. Renders the supplied wordmark SVGs
 * unchanged — `kin-logo-dark.svg` in dark mode (light wordmark on dark
 * page), `kin-logo-light.svg` otherwise. Both are transparent-background;
 * the chevrons are color-mode-agnostic (#3D2BFF), only the wordmark text
 * fill differs between the two files.
 *
 * Sized so the height controls the layout; width follows the SVG's
 * 243:120 viewBox aspect.
 */

import { useTheme } from '../theme/ThemeProvider.js';

export function Brand({ height = 30 }: { height?: number }) {
  const { resolved } = useTheme();
  const src = resolved === 'dark' ? '/kin-logo-dark.svg' : '/kin-logo-light.svg';
  return (
    <img
      src={src}
      alt="Kin"
      height={height}
      style={{ height, width: 'auto' }}
      className="block select-none"
      draggable={false}
    />
  );
}
